<template>
    <a @click="open" v-html="linkTitle" v-if="linkTitle" class="cursor-pointer"></a>
    <modal v-if="showModal" @close="close" ref="modalType" overlay="true" className="lg:w-3/5 md:w-3/4 md:-mt-16">
        <template #header>
            <div v-html="header" class="text-lg text-left"></div>
        </template>
        <template #body>
            <div class="text-left">
                <p class="text-sm text-gray-800" v-html="description"></p>
                <p v-if="moreinfo" class="text-sm italic text-gray-500 mb-3" v-html="moreinfo"></p>
                <div class="__embed-responsive __aspect-ratio-16/9">
                    <video id="videoModal" controls="controls" controlsList="nodownload" oncontextmenu="return false;" class="w-full __embed-responsive-item" :src="url"></video>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-end">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="close">Close</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    url: String,
    linkTitle: String,
    description: String,
    header: String,
    moreinfo: String,
    autoplay: String,
    modalvideo: Boolean,
});

const emit = defineEmits(['close']);

const showModal = ref(false);

const close = () => {
    showModal.value = false;
    if (props.modalvideo) {
        emit('close');
    }
};

const open = () => {
    showModal.value = true;

    if (props.autoplay === 'true') {
        setTimeout(() => {
            const video = document.getElementById('videoModal');
            if (video) {
                video.play();
            }
        }, 1000);
    }
};

onMounted(() => {
    if (props.modalvideo) {
        showModal.value = true;
        setTimeout(() => {
            const video = document.getElementById('videoModal');
            if (video) {
                video.play();
            }
        }, 1000);
    }
});
</script>
